import { render, staticRenderFns } from "./StockRecordDetail.vue?vue&type=template&id=33ee2392&scoped=true&"
import script from "./StockRecordDetail.vue?vue&type=script&lang=js&"
export * from "./StockRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockRecordDetail.vue?vue&type=style&index=0&id=33ee2392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee2392",
  null
  
)

export default component.exports